import React from "react";

interface EachProps {
  render: (item: any, index: number) => React.ReactNode,
  of: any[]
}

const Each = ({ render, of }: EachProps) => React.Children.toArray(of.map((item, index) => render(item, index)));

export default Each;